import { render, staticRenderFns } from "./ClientAddress.vue?vue&type=template&id=4b6fc572"
import script from "./ClientAddress.vue?vue&type=script&lang=js"
export * from "./ClientAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports